import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { GetNotificationLatestNewsResponse } from '../apis';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

interface useGetNotificationLatestNewsData {
  time: string;
  title: 'morning' | 'snack' | 'evening' | 'restroom';
}

const useGetNotificationLatestNews = () => {
  return useQuery({
    queryKey: ['notificationLatestNews'],
    queryFn: async () => {
      const { data } = await clientAxios.get<
        ApiResponse<GetNotificationLatestNewsResponse>
      >('/getNotificationLatestNewsApi/');

      const { noti_time_latest_news, noti_title_latest_news } = data.data;

      const modifiedTime = noti_time_latest_news.toString().padStart(4, '0');
      const response: useGetNotificationLatestNewsData = {
        time: modifiedTime,
        title: noti_title_latest_news as
          | 'morning'
          | 'snack'
          | 'evening'
          | 'restroom',
      };
      return response;
    },
    placeholderData: keepPreviousData,
  });
};

export default useGetNotificationLatestNews;
